export default "__VITE_ASSET__dDWPGytH__"